import FormField from "../form-field";
import PhotoInput from "../inputs/photo-input";

export default class PhotoField extends FormField {
	constructor(props) {
		super(props);

		this.inputModule = null;
		this.$hiddenPhotoUrl = null;

		this.init();
	}

	init() {
		if (!this.$root) {
			throw new Error('PhotoField: Root element is not defined!');
		}

		this.$hiddenPhotoUrl = this.$root.querySelector('[name="photoUrl"]');

		const $input = this.$root.querySelector('.photo-input');
		this.inputModule = new PhotoInput({ $root: $input });

		super.init();
	}

	addEventListeners() {
		this.inputModule.subscribe(this.VALUE_CHANGE_EVENT, ({ detail }) => {
			this.setValue(detail);
		});
	}

	setValue(value) {
		this.value = value;

		if (this.value != null) {
			this.setStatus('valid');
		} else {
			this.setStatus('neutral');
		}

		this.dispatchEvent(this.VALUE_CHANGE_EVENT, this.value);
	}

	setInitialState() {
		this.inputModule.dropState();
	}

	setInitialValue(value) {
		this.$hiddenPhotoUrl.value = value;
	}

	getData() {
		const data = {}

		if (this.value != null) {
			Object.assign(data, { 'photoBase64': this.value });
		}

		if (this.$hiddenPhotoUrl.value) {
			Object.assign(data, { 'photoUrl': this.$hiddenPhotoUrl.value });
		}

		return Object.keys(data).length ? data : null;
	}
}